export const isCurrentOrPastTournamentYear = ({ year }) => year <= new Date().getFullYear() + 4;

export const hasSettings = ({ generalRosterSettings, mainTournamentSettings, qualifyingTournamentSettings }) =>
  !!generalRosterSettings && !!mainTournamentSettings && !!qualifyingTournamentSettings;
